if (!customElements.get('dc-subscribe-dialog')) {
  class DelmicureSubscribeDialog extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.openFromLink = (event) => {
        const link = event.target.closest('a[href="#DelmicureNewsletter"]');
        if (!link) return;
        event.preventDefault();
        this.open();
      };
      this.close = () => this.dialog.close();
      this.backdrop = (event) => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.close();
      };
      this.measure = () => {
        const bar = this.closest('.shopify-section');
        if (bar) document.documentElement.style.setProperty('--dc-announcement-height', `${bar.getBoundingClientRect().height}px`);
      };
      document.addEventListener('click', this.openFromLink);
      this.querySelector('[data-subscribe-close]').addEventListener('click', this.close);
      this.dialog.addEventListener('click', this.backdrop);
      this.observer = new ResizeObserver(this.measure);
      this.observer.observe(this.closest('.shopify-section'));
      this.measure();
      if (this.querySelector('[data-subscribe-result]')) this.open();
    }
    open() {
      if (!this.dialog.open) this.dialog.showModal();
      const target = this.querySelector('[data-subscribe-result]') || this.querySelector('input[type="email"]');
      target?.focus();
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.openFromLink);
      this.querySelector('[data-subscribe-close]').removeEventListener('click', this.close);
      this.dialog.removeEventListener('click', this.backdrop);
      this.observer.disconnect();
    }
  }
  customElements.define('dc-subscribe-dialog', DelmicureSubscribeDialog);
}
